import React from 'react';
import { Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, withApollo } from 'react-apollo';

import Loading from '../../../common/Loading';

import FormArticulo from './FormArticulo';

import updateArticulo from '../../../../graphql/mutations/articulos/updateArticulo.graphql';
import getArticuloPorId from '../../../../graphql/querys/articulos/getArticuloPorId.graphql';
import { errorService } from '../../../../graphql/utils/utils';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@graphql(updateArticulo, {
  name: 'updateArticulo',
})
class EditarArticulo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      step: 0,
      loading: true,
      articulo: {},
    };

    this.props.client
      .query({
        query: getArticuloPorId,
        variables: { _id: this.props.match.params.id },
      })
      .then(res => {
        const articulo = res.data.getArticuloPorId;
        // console.log("Respuesta exitosa!");
        // console.log(articulo);

        this.setState({
          loading: false,
          articulo: articulo,
        });
      })
      .catch(err => {
        console.log('Error en la creacion');
        console.log(err);
        errorService(err, {
          _id: this.props.match.params.id,
        });
        Modal.error({
          title: 'Error en la inicializacion del componente grafico',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });

    this.guardarArticulo = this.guardarArticulo.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  guardarArticulo(articulo) {
    // console.log("articulo...");
    // console.log(articulo);
    this.setState(
      {
        articulo: {
          ...this.state.articulo,
          ...articulo,
        },
      },
      function() {
        let nuevoArticulo = this.state.articulo;
        delete nuevoArticulo.__typename;
        delete nuevoArticulo._id;

        this.props
          .updateArticulo({
            variables: {
              _id: this.props.match.params.id,
              nuevoArticulo: this.state.articulo,
            },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Actualizacion Correcta',
              description: 'Se ha registrado los nuevos datos del articulo',
            });

            this.props.history.push('/admin/otros/articulos');
          })
          .catch(err => {
            console.log('Error en la actualizacion del articulo');
            console.log(err);
            errorService(err, {
              _id: this.props.match.params.id,
              nuevoArticulo: this.state.articulo,
            });

            Modal.error({
              title: 'Error en la actualizacion de la articulo',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      }
    );
  }

  onCancel() {
    this.setState({
      fase: 0,
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Articulo</Breadcrumb.Item>
          <Breadcrumb.Item>Editar</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Editar Articulo
          </h2>
          <br />
          <div style={estiloContent}>
            <FormArticulo
              className="formularios"
              onSubmit={this.guardarArticulo}
              onAnterior={() =>
                this.props.history.push('/admin/otros/articulos')
              }
              datos={this.state.articulo}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(EditarArticulo);
